export const RITHMIC_ACCOUNTS_FILTERS = {
  Email: "email",
  Accounts: "accounts",
};
